import Vue from 'vue'
import App from './components/ecosystems/App.vue'
import VueRouter from 'vue-router'
import routes from './routes'
import VueSlideToggle from 'vue-slide-toggle'
import jquery from 'jquery'
import VueAnalytics from 'vue-analytics'
window.jQuery = jquery

Vue.use(VueSlideToggle)
Vue.use(VueRouter)

const router = new VueRouter({ routes, linkExactActiveClass: 'active', mode: 'history' })

Vue.use(VueAnalytics, {
  id: 'UA-125729084-2',
  router
})

new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js